import AssessmentBlock from '../AssessmentBlock';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';

class SelfAssessmentBlock extends AssessmentBlock {

	constructor(props) {
		super(props);
		this.name = 'Haldor.Blocks.AssessmentBlock.Self';
		this.block_type = 'expandable_block';
		this.assessmentType = ASSESSMENT_TYPES.SELF;
	}

	editorBlockWasAdded = () => {
		const editor = this.api.getEditor();
		const translate = editor.getProp('translate');
		let editMode = false;
		const selfAssessments = editor.getBlocks().filter(block => {
			return block.assessmentType == ASSESSMENT_TYPES.SELF
		});

		editor.getBlocks().forEach(block => {
			editMode = block.resources?.length > 0 && block.resources.every((s) => {
				return s.id != null && s.id > 0
			});
		});

		if (editMode) {
			const foundIndex = selfAssessments.findIndex((b) => b.field == this.field);
			this.events.onTitleChange(translate('Self assessment') + ' ' + (foundIndex + 1));
		} else {
			this.events.onTitleChange(translate('Self assessment') + ' ' + selfAssessments.length);
		}

		const disableRows = editor.getProp('disableRows');
		if (disableRows != null && disableRows.length > 0 && this.resources != null) {
			const disabled = this.getResources().find((resource) => {
				return resource.assessmentBlockPartRows?.findIndex((row) =>
					disableRows.includes(row.id)
				) > -1;
			}) != null;

			if (disabled) {
				this.api.deregisterAction('Remove');
			}
		}
	}

	addGoalMatrix = (event) => {
		event.preventDefault();

		this.addResource(this.PART_RESOURCE_TYPE, {
			status: 'Started',
			referenceId: '',
			referenceType: 'assessmentGoal',
			value: {
				id: 0,
				visibleToStudent: true,
				visibleToGuardian: true,
				title: '',
				rows: [],
			},
			permissions: []
		});
	}
}

export default SelfAssessmentBlock;